import {
  getAllCopies,
  getFilteredCopies,
  postCopy,
  updateCopy,
  disableCopy
} from '@/api/Erp'

export default {
  async getAllCopies(page, size, product_id, token) {
    try {
      const response = await getAllCopies.get({
        uriParams: {
          page,
          size,
          product_id
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  },
  async getFilteredCopies(is_active, page, size, product_id, token) {
    try {
      const response = await getFilteredCopies.get({
        uriParams: {
          is_active,
          page,
          size,
          product_id
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  },
  async postCopy(payload, token) {
    try {
      const response = await postCopy.post(
        payload,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      )
      return response
    } catch (error) {
      return error.response
    }
  },
  async updateCopy(payload, token) {
    try {
      const response = await updateCopy.patch(
        {
          copy_name: payload.copy_name,
          copy_is_active: payload.copy_is_active,
          product: {
            product_id: payload.product.product_id
          }
        },
        {
          uriParams: {
            id: payload.copy_id
          },
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      )
      return response
    } catch (error) {
      return error.response
    }
  },
  async disableCopy(payload, token) {
    try {
      const copy_id = payload.copy_id
      const response = await disableCopy.delete({
        uriParams: {
          id: copy_id
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/copy/resources.js